import { render, staticRenderFns } from "./POSTransactionSettlementToggler.vue?vue&type=template&id=617422af&"
import script from "./POSTransactionSettlementToggler.vue?vue&type=script&lang=js&"
export * from "./POSTransactionSettlementToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports